// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

    --gray: #34495e;
    --darkgray: #2c3e50;
}
td,th{
    color:white;
    border-bottom: 1px solid #2c3845;
    font-family: Montserrat, sans-serif;
    padding: 16px;
    text-align: center;
}
.contianer_info_wagering{
    display: flex;
    justify-content: center;
    background-color: #0101025e;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
.variant_buttons{
    margin-top: 20px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;

}
.variant_buttons_history{
    margin-top: 0px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    gap: 10px;
}
.select{
    margin-top: 50px;
}
.fade_history {
    opacity: 1;
    transition: opacity 2s ease-in-out;
}

.fade_history:not(.loadingHistory) {
    opacity: 0;
}
select {
    /* Reset Select */
    appearance: none;
    outline: 10px red;
    border: 0;
    box-shadow: none;
    /* Personalize */
    flex: 1 1;
    padding: 0 1em;
    color: #fff;
    font-family: "Gilroy" , sans-serif;
    font-size: 18px;
    font-weight: 600;
    background-color: var(--darkgray);
    background-image: none;
    cursor: pointer;
}
/* Remove IE arrow */
select::-ms-expand {
    display: none;
}
/* Custom Select wrapper */
.select {
    position: relative;
    display: flex;
    width: 20em;
    height: 3em;
    border-radius: .25em;
    overflow: hidden;
}

/* Arrow */
.select::after {
    content: '\\25BC';
    position: absolute;
    top: 0;
    right: 0;
    padding: 1em;
    background-color: #34495e;
    transition: .25s all ease;
    pointer-events: none;
}
/* Transition */
.select:hover::after {
    color: #f39c12;
}



.variant_buttons div{

    display: flex;
    font-size: 22px;
    width: 150px;
    justify-content: center;
    background: #48567d;
    border-radius: 10px;
    box-shadow: 0 8px 10px #000;
    box-sizing: border-box;
    padding: 12px;
    position: relative;
    color: #eaf0fb;
    text-align: center;
    cursor: pointer;
    font-family: Poppins , sans-serif;

}
.variant_buttons_history div{
    display: flex;
    font-size: 18px;
    width: 110px;
    justify-content: center;
    background: linear-gradient(180deg, #4d5a8596, rgb(70 82 121 / 36%));
    border-radius: 5px;
    box-shadow: 0 8px 10px #000;
    box-sizing: border-box;
    padding: 8px;
    position: relative;
    color: #eaf0fb;
    text-align: center;
    cursor: pointer;
    font-family: Poppins , sans-serif;
}
.variant_buttons div.active{
    background-color: #85007E;

}
.variant_buttons_history div.active{
    background-color: #85007E;


}
.commisia{
    text-align: center;
    pointer-events: none;
    font-size: 14px;
    color: ghostwhite; /* Цвет текста placeholder */
    font-family: "Gilroy" , sans-serif;
    font-weight: 600;
}
.payments{
    
    min-height:100vh;
    margin-bottom: 30px;
    display: flex;

    flex-direction: column;

}
.cards {

    display: flex;
    justify-content: center;
    gap: 10px;

    flex-wrap: wrap; /* Добавляем перенос на новую строку */
    background:#0a0f23;
    padding-top: 8px;
    padding-bottom: 8px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 0px 0px 8px 2px #000;

}
.block_infCard{
    position: relative  ;
    top:0;
    left: 0;
    font-family: Popins,sans-serif;
    background-color: #224258;
    padding: 5px;
    border-radius: 10px;
}
.card {
    position: relative;
    padding: 6px;
    color: #fff;
    background: #281e4b;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s;
    outline: none;
    display: flex;
    justify-content: center;
    align-items: center;

}

.card.active {
    background-color: #85007E;

}

.btn-grad {
    background-image: linear-gradient(to right, #2b5876 0%, #4e4376  51%, #2b5876  100%);
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
}

.btn-grad:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}
.inf{
    display: flex;
    justify-content: center;
    flex-direction: column;

}
.search-wrapper_payment.active {}

.search-wrapper_payment .input-holder {
    height: 50px;
    width:70px;
    overflow: hidden;
    border-radius:6px;
    position: relative;
    transition: all 0.3s ease-in-out;
}
.search-wrapper_payment.active .input-holder {
    width:100%;
    border-radius: 15px;
    background: rgba(23, 26, 26, 0.5);
    transition: all .5s cubic-bezier(0.000, 0.105, 0.035, 1.570);
}
.search_box{
    display: flex;
    flex-direction: column;
    justify-content: center;

}
.search-wrapper_payment.active .input-holder.pays{
    /*width: 380px!important;*/
}
.form_pays{
    display: block;
    width: 300px;
    background-color: #ffffff12;
    border-radius: 3px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 300;
    height: 50px;
    padding: 0 10px;
}
.wrraper_center{
    display: flex;
    justify-content: center;
}
.comma_block{
    margin-top: 10px;
    background-color: #0000006e;
    padding: 10px;
    border-radius: 10px;
}
.search-wrapper_payment .input-holder .search-input {
    width:100%;
    height: 30px;
    padding:10px;
    padding-left: 15px;
    opacity: 0;
    position: absolute;
    top:0px;
    left:0px;
    background: transparent;
    box-sizing: border-box;
    border:none;
    outline:none;
    font-family: Poppins, sans-serif;
    font-size:17px;
    font-weight: 400;
    line-height: 20px;
    color:#FFF;
    transform: translate(0, 60px);
    transition: all .3s cubic-bezier(0.000, 0.105, 0.035, 1.570);
    transition-delay: 0.3s;
}
.search-wrapper_payment .input-holder .search-input::-webkit-input-placeholder{
    color: white;

    font-family:"Open Sans", Arial, Verdana;
    font-size: 14px;
    font-weight: 400;
}
.search-wrapper_payment.active .input-holder .search-input {
    opacity: 1;
    transform: translate(0, 10px);
}
.search-input.pays::placeholder{
    /*text-align: center!important;*/
}
.search-wrapper_payment .input-holder .search-icon {
    width:70px;
    height:70px;
    border:none;
    border-radius:6px;
    background: #FFF;
    padding:0px;
    outline:none;
    position: relative;
    z-index: 2;
    float:right;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}
.search-wrapper_payment.active .input-holder .search-icon {
    width: 50px;
    height:50px;
    margin: 10px;
    border-radius: 30px;
}
.search-wrapper_payment .input-holder .search-icon span {
    width:22px;
    height:22px;
    display: inline-block;
    vertical-align: middle;
    position:relative;
    transform: rotate(45deg);
    transition: all .4s cubic-bezier(0.650, -0.600, 0.240, 1.650);
}
.search-wrapper_payment.active .input-holder .search-icon span {
    transform: rotate(-45deg);
}
.search-wrapper_payment .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {
    position: absolute;
    content:'';
}
/*.input-holder {*/
/*    position: relative;*/
/*}*/
.placeholder-label {
    margin-bottom: 10px;
    pointer-events: none;
    font-size: 14px;
    color: white; /* Цвет текста placeholder */
    font-family: "Gilroy" , sans-serif;
    font-weight: 600;
    margin-left: 10px;
}
/*.search-input {*/
/*    padding: 20px 10px; !* Добавить вертикальное пространство для текста над полем ввода *!*/
/*    font-size: 16px; !* Размер шрифта *!*/
/*    border: 1px solid #ccc; !* Граница поля ввода *!*/
/*}*/
/*.search-input:focus + .placeholder-label,*/
/*.search-input:valid + .placeholder-label {*/
/*    transform: translateY(-100%); !* Поднять текст над полем ввода при фокусе или заполнении *!*/
/*}*/

.btn{
    display: flex;
    justify-content: center;
}
.buttonPlus {
    padding: 5px 10px;
    border-radius: 15px;

    /*background-color: #46bebd;*/
    color: white;
    box-sizing: border-box;
    height: 47px; /* Новая высота */
    font-size: 20px;
    background: #8e00a5;
    
    background-size: 400%;
    border: none;
    cursor: pointer;
    font-family: Arial, sans-serif;
    width: 150px;
    justify-content: center;
}
:where(.css-dev-only-do-not-override-garjc0).ant-select-single{
    width: 100%!important;
    border-radius: 15px!important;
    height: 50px!important;
    border: none!important;
    box-shadow: none!important;

}
:where(.css-dev-only-do-not-override-garjc0).ant-select .ant-select-arrow{
    color:white;
}
:where(.css-dev-only-do-not-override-garjc0).ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled):hover{
    background-color: rgba(37, 230, 95, 0.61);
}
:where(.css-dev-only-do-not-override-garjc0).ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled){
    background-color: rgba(37, 230, 95, 0.61);
}
@keyframes animate {
    0% {
        background-position: 0%;
    }
    100% {
        background-position: 400%;
    }
}
.buttonPlus:hover {
    animation: animate 4s linear infinite;
}
.wrrapper_form{
    display: flex;
    justify-content: center;
}
.cards.no{
    margin-left: 0px;
}
.mainCt{
    animation: errorAppear 1s ease-in-out;
    animation-fill-mode: forwards;
    background: linear-gradient(#065a65, #148c1ec2);
   
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 10px 35px;
    position: relative;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;


}
@keyframes errorAppear {
    0% {
        opacity: 0;

    }
    100% {
        opacity: 1;

    }
}
.mainCtTable{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /*margin: 0 auto;*/
    margin-top: 20px;
}
@media (max-width: 550px) {
    .variant_buttons div{
        width: 23%;
        font-size: 16px;
        gap: 5px;
    }
    
}
.loadp{
    text-align:center;
    font-size:22px;
    white-space: nowrap;
}
.loadp i {
    display: inline-block; /* Делает иконку блочным элементом, чтобы она не влияла на текст */
    margin-left: 3px; /* Добавляет отступ слева от иконки для разделения от текста */
}
.fadeBack{
    animation: errorAppear 0.8s ease-in-out;
    animation-fill-mode: forwards;
    margin-left: 0px;
}

.history{
    max-width: 700px!important;
}
.succsesIcon{
    color:greenyellow;
}
.fa-spin{
    color: #ff9c1d;
}
.order_id{
    cursor: pointer;
}
.head_crypto {
    color: white;
    font-size: 20px;
    font-family: "Montserrat", sans-serif;
    padding: 10px;
    position: relative;
}
.mainContCrypto{
    position: relative;
    display: flex;
    flex-direction: column;
    gap:10px;
    background-color: #0a0f23;
    padding-top: 8px;
    padding-bottom: 8px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 0px 0px 8px 2px #000;
}
.blockInfCrypto{
    display: flex;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    border: 2px solid #281e4b;
    justify-content: center;
    color:white;
    font-family: monospace,sans-serif;
}
.wrapper_crypto{
    display: flex;
    flex-direction: column;
    gap:8px;
}

.head_crypto:before {

    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: -10px;
    width: 100%;
    height: 2px;
    background: #8080801f;
    margin-bottom: 10px;


}
.blockInfoSupport{
    display: flex;
    justify-content: center;
    padding: 10px;
    align-items: center;
    border-radius: 10px;
    font-family: monospace,sans-serif;
    background-color: rgba(0, 0, 0, 0.375);
    cursor: pointer;
    color:white!important;
    margin-bottom: 5px;
}
.veriff-description{
    display: none;
}
.blockInfoSupport.warning{
    background-color: rgb(137 121 30 / 28%);
    color:gold!important;
    cursor: default;
}
.dangerIcon{
    color:red;
}
.payment_block{
    display: flex;
    justify-content: center;
    max-width: 800px;

}
.wrapper_payment{
    display: flex;
    flex-direction: column;

    
    margin-top: 20px;


}
.wrapper_payment_block{
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 1000px) {
    
    .mainCt{
        padding: 10px 10px;
        display: flex;
        width: 100%;
    }
    .payments{
        margin-top: 60px;
        margin-bottom: 50px;
        min-height: 50svh;
    }
    
   
    .search-wrapper_payment.active .input-holder.pays{
        width: 100%!important;
    }

    .loadp{
        font-size: 17px!important;
    }

    .history{
        max-width: 400px !important;
    }

}
@media screen and (min-width: 1000px) {
    

    
    .fadeBack {
        margin: 20px 0px 10px 20px;
    }
    .card {
        height: 120px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Payments/payments.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gCAAgC;IAChC,mCAAmC;IACnC,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,QAAQ;;AAEZ;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,SAAO;IACP,cAAc;IACd,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,sBAAsB;IACtB,eAAe;AACnB;AACA,oBAAoB;AACpB;IACI,aAAa;AACjB;AACA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;AACxB;AACA,eAAe;AACf;IACI,cAAc;AAClB;;;;AAIA;;IAEI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iCAAiC;;AAErC;AACA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,oEAAoE;IACpE,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,yBAAyB;;AAE7B;AACA;IACI,yBAAyB;;;AAG7B;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,iBAAiB,EAAE,4BAA4B;IAC/C,kCAAkC;IAClC,gBAAgB;AACpB;AACA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;;IAEb,sBAAsB;;AAE1B;AACA;;IAEI,aAAa;IACb,uBAAuB;IACvB,SAAS;;IAET,eAAe,EAAE,sCAAsC;IACvD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;;AAEpC;AACA;IACI,oBAAoB;IACpB,KAAK;IACL,OAAO;IACP,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,oFAAoF;IACpF,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iCAAiC,EAAE,4CAA4C;IAC/E,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;;AAE1B;AACA,gCAAgC;;AAEhC;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,iCAAiC;IACjC,4DAA4D;AAChE;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;;AAE3B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,6BAA6B;IAC7B,4DAA4D;IAC5D,sBAAsB;AAC1B;AACA;IACI,YAAY;;IAEZ,uCAAuC;IACvC,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,6BAA6B;AACjC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,UAAU;IACV,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,wBAAwB;IACxB,6DAA6D;AACjE;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA,kBAAkB;AAClB,0BAA0B;AAC1B,IAAI;AACJ;IACI,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,YAAY,EAAE,4BAA4B;IAC1C,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;AACrB;AACA,kBAAkB;AAClB,8FAA8F;AAC9F,2CAA2C;AAC3C,uDAAuD;AACvD,IAAI;AACJ,4CAA4C;AAC5C,6CAA6C;AAC7C,kGAAkG;AAClG,IAAI;;AAEJ;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,mBAAmB;;IAEnB,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;IACtB,YAAY,EAAE,iBAAiB;IAC/B,eAAe;IACf,mBAAmB;;IAEnB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;;AAE9B;AACA;IACI,WAAW;AACf;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,yCAAyC;AAC7C;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,qCAAqC;AACzC;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,+CAA+C;;IAE/C,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;;;AAGpC;AACA;IACI;QACI,UAAU;;IAEd;IACA;QACI,UAAU;;IAEd;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI;QACI,UAAU;QACV,eAAe;QACf,QAAQ;IACZ;;AAEJ;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,qBAAqB,EAAE,kEAAkE;IACzF,gBAAgB,EAAE,8DAA8D;AACpF;AACA;IACI,uCAAuC;IACvC,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,mBAAmB;;;AAGvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;IACjC,sCAAsC;IACtC,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,uCAAuC;IACvC,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,sBAAsB;;;IAGtB,gBAAgB;;;AAGpB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;;IAEI;QACI,kBAAkB;QAClB,aAAa;QACb,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;IACrB;;;IAGA;QACI,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;AAEJ;AACA;;;;IAII;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[":root {\r\n\r\n    --gray: #34495e;\r\n    --darkgray: #2c3e50;\r\n}\r\ntd,th{\r\n    color:white;\r\n    border-bottom: 1px solid #2c3845;\r\n    font-family: Montserrat, sans-serif;\r\n    padding: 16px;\r\n    text-align: center;\r\n}\r\n.contianer_info_wagering{\r\n    display: flex;\r\n    justify-content: center;\r\n    background-color: #0101025e;\r\n    border-bottom-left-radius: 10px;\r\n    border-bottom-right-radius: 10px;\r\n}\r\n.variant_buttons{\r\n    margin-top: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    gap: 5px;\r\n\r\n}\r\n.variant_buttons_history{\r\n    margin-top: 0px;\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 10px;\r\n}\r\n.select{\r\n    margin-top: 50px;\r\n}\r\n.fade_history {\r\n    opacity: 1;\r\n    transition: opacity 2s ease-in-out;\r\n}\r\n\r\n.fade_history:not(.loadingHistory) {\r\n    opacity: 0;\r\n}\r\nselect {\r\n    /* Reset Select */\r\n    appearance: none;\r\n    outline: 10px red;\r\n    border: 0;\r\n    box-shadow: none;\r\n    /* Personalize */\r\n    flex: 1;\r\n    padding: 0 1em;\r\n    color: #fff;\r\n    font-family: \"Gilroy\" , sans-serif;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    background-color: var(--darkgray);\r\n    background-image: none;\r\n    cursor: pointer;\r\n}\r\n/* Remove IE arrow */\r\nselect::-ms-expand {\r\n    display: none;\r\n}\r\n/* Custom Select wrapper */\r\n.select {\r\n    position: relative;\r\n    display: flex;\r\n    width: 20em;\r\n    height: 3em;\r\n    border-radius: .25em;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Arrow */\r\n.select::after {\r\n    content: '\\25BC';\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    padding: 1em;\r\n    background-color: #34495e;\r\n    transition: .25s all ease;\r\n    pointer-events: none;\r\n}\r\n/* Transition */\r\n.select:hover::after {\r\n    color: #f39c12;\r\n}\r\n\r\n\r\n\r\n.variant_buttons div{\r\n\r\n    display: flex;\r\n    font-size: 22px;\r\n    width: 150px;\r\n    justify-content: center;\r\n    background: #48567d;\r\n    border-radius: 10px;\r\n    box-shadow: 0 8px 10px #000;\r\n    box-sizing: border-box;\r\n    padding: 12px;\r\n    position: relative;\r\n    color: #eaf0fb;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-family: Poppins , sans-serif;\r\n\r\n}\r\n.variant_buttons_history div{\r\n    display: flex;\r\n    font-size: 18px;\r\n    width: 110px;\r\n    justify-content: center;\r\n    background: linear-gradient(180deg, #4d5a8596, rgb(70 82 121 / 36%));\r\n    border-radius: 5px;\r\n    box-shadow: 0 8px 10px #000;\r\n    box-sizing: border-box;\r\n    padding: 8px;\r\n    position: relative;\r\n    color: #eaf0fb;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-family: Poppins , sans-serif;\r\n}\r\n.variant_buttons div.active{\r\n    background-color: #85007E;\r\n\r\n}\r\n.variant_buttons_history div.active{\r\n    background-color: #85007E;\r\n\r\n\r\n}\r\n.commisia{\r\n    text-align: center;\r\n    pointer-events: none;\r\n    font-size: 14px;\r\n    color: ghostwhite; /* Цвет текста placeholder */\r\n    font-family: \"Gilroy\" , sans-serif;\r\n    font-weight: 600;\r\n}\r\n.payments{\r\n    \r\n    min-height:100vh;\r\n    margin-bottom: 30px;\r\n    display: flex;\r\n\r\n    flex-direction: column;\r\n\r\n}\r\n.cards {\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 10px;\r\n\r\n    flex-wrap: wrap; /* Добавляем перенос на новую строку */\r\n    background:#0a0f23;\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    box-shadow: 0px 0px 8px 2px #000;\r\n\r\n}\r\n.block_infCard{\r\n    position: relative  ;\r\n    top:0;\r\n    left: 0;\r\n    font-family: Popins,sans-serif;\r\n    background-color: #224258;\r\n    padding: 5px;\r\n    border-radius: 10px;\r\n}\r\n.card {\r\n    position: relative;\r\n    padding: 6px;\r\n    color: #fff;\r\n    background: #281e4b;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    transition: all 0.3s;\r\n    outline: none;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n}\r\n\r\n.card.active {\r\n    background-color: #85007E;\r\n\r\n}\r\n\r\n.btn-grad {\r\n    background-image: linear-gradient(to right, #2b5876 0%, #4e4376  51%, #2b5876  100%);\r\n    margin: 10px;\r\n    padding: 15px 45px;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    color: white;\r\n    box-shadow: 0 0 20px #eee;\r\n    border-radius: 10px;\r\n    display: block;\r\n}\r\n\r\n.btn-grad:hover {\r\n    background-position: right center; /* change the direction of the change here */\r\n    color: #fff;\r\n    text-decoration: none;\r\n}\r\n.inf{\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n\r\n}\r\n.search-wrapper_payment.active {}\r\n\r\n.search-wrapper_payment .input-holder {\r\n    height: 50px;\r\n    width:70px;\r\n    overflow: hidden;\r\n    border-radius:6px;\r\n    position: relative;\r\n    transition: all 0.3s ease-in-out;\r\n}\r\n.search-wrapper_payment.active .input-holder {\r\n    width:100%;\r\n    border-radius: 15px;\r\n    background: rgba(23, 26, 26, 0.5);\r\n    transition: all .5s cubic-bezier(0.000, 0.105, 0.035, 1.570);\r\n}\r\n.search_box{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n\r\n}\r\n.search-wrapper_payment.active .input-holder.pays{\r\n    /*width: 380px!important;*/\r\n}\r\n.form_pays{\r\n    display: block;\r\n    width: 300px;\r\n    background-color: #ffffff12;\r\n    border-radius: 3px;\r\n    box-sizing: border-box;\r\n    font-size: 14px;\r\n    font-weight: 300;\r\n    height: 50px;\r\n    padding: 0 10px;\r\n}\r\n.wrraper_center{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.comma_block{\r\n    margin-top: 10px;\r\n    background-color: #0000006e;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n}\r\n.search-wrapper_payment .input-holder .search-input {\r\n    width:100%;\r\n    height: 30px;\r\n    padding:10px;\r\n    padding-left: 15px;\r\n    opacity: 0;\r\n    position: absolute;\r\n    top:0px;\r\n    left:0px;\r\n    background: transparent;\r\n    box-sizing: border-box;\r\n    border:none;\r\n    outline:none;\r\n    font-family: Poppins, sans-serif;\r\n    font-size:17px;\r\n    font-weight: 400;\r\n    line-height: 20px;\r\n    color:#FFF;\r\n    transform: translate(0, 60px);\r\n    transition: all .3s cubic-bezier(0.000, 0.105, 0.035, 1.570);\r\n    transition-delay: 0.3s;\r\n}\r\n.search-wrapper_payment .input-holder .search-input::-webkit-input-placeholder{\r\n    color: white;\r\n\r\n    font-family:\"Open Sans\", Arial, Verdana;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n}\r\n.search-wrapper_payment.active .input-holder .search-input {\r\n    opacity: 1;\r\n    transform: translate(0, 10px);\r\n}\r\n.search-input.pays::placeholder{\r\n    /*text-align: center!important;*/\r\n}\r\n.search-wrapper_payment .input-holder .search-icon {\r\n    width:70px;\r\n    height:70px;\r\n    border:none;\r\n    border-radius:6px;\r\n    background: #FFF;\r\n    padding:0px;\r\n    outline:none;\r\n    position: relative;\r\n    z-index: 2;\r\n    float:right;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease-in-out;\r\n}\r\n.search-wrapper_payment.active .input-holder .search-icon {\r\n    width: 50px;\r\n    height:50px;\r\n    margin: 10px;\r\n    border-radius: 30px;\r\n}\r\n.search-wrapper_payment .input-holder .search-icon span {\r\n    width:22px;\r\n    height:22px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    position:relative;\r\n    transform: rotate(45deg);\r\n    transition: all .4s cubic-bezier(0.650, -0.600, 0.240, 1.650);\r\n}\r\n.search-wrapper_payment.active .input-holder .search-icon span {\r\n    transform: rotate(-45deg);\r\n}\r\n.search-wrapper_payment .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {\r\n    position: absolute;\r\n    content:'';\r\n}\r\n/*.input-holder {*/\r\n/*    position: relative;*/\r\n/*}*/\r\n.placeholder-label {\r\n    margin-bottom: 10px;\r\n    pointer-events: none;\r\n    font-size: 14px;\r\n    color: white; /* Цвет текста placeholder */\r\n    font-family: \"Gilroy\" , sans-serif;\r\n    font-weight: 600;\r\n    margin-left: 10px;\r\n}\r\n/*.search-input {*/\r\n/*    padding: 20px 10px; !* Добавить вертикальное пространство для текста над полем ввода *!*/\r\n/*    font-size: 16px; !* Размер шрифта *!*/\r\n/*    border: 1px solid #ccc; !* Граница поля ввода *!*/\r\n/*}*/\r\n/*.search-input:focus + .placeholder-label,*/\r\n/*.search-input:valid + .placeholder-label {*/\r\n/*    transform: translateY(-100%); !* Поднять текст над полем ввода при фокусе или заполнении *!*/\r\n/*}*/\r\n\r\n.btn{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.buttonPlus {\r\n    padding: 5px 10px;\r\n    border-radius: 15px;\r\n\r\n    /*background-color: #46bebd;*/\r\n    color: white;\r\n    box-sizing: border-box;\r\n    height: 47px; /* Новая высота */\r\n    font-size: 20px;\r\n    background: #8e00a5;\r\n    \r\n    background-size: 400%;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-family: Arial, sans-serif;\r\n    width: 150px;\r\n    justify-content: center;\r\n}\r\n:where(.css-dev-only-do-not-override-garjc0).ant-select-single{\r\n    width: 100%!important;\r\n    border-radius: 15px!important;\r\n    height: 50px!important;\r\n    border: none!important;\r\n    box-shadow: none!important;\r\n\r\n}\r\n:where(.css-dev-only-do-not-override-garjc0).ant-select .ant-select-arrow{\r\n    color:white;\r\n}\r\n:where(.css-dev-only-do-not-override-garjc0).ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled):hover{\r\n    background-color: rgba(37, 230, 95, 0.61);\r\n}\r\n:where(.css-dev-only-do-not-override-garjc0).ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled){\r\n    background-color: rgba(37, 230, 95, 0.61);\r\n}\r\n@keyframes animate {\r\n    0% {\r\n        background-position: 0%;\r\n    }\r\n    100% {\r\n        background-position: 400%;\r\n    }\r\n}\r\n.buttonPlus:hover {\r\n    animation: animate 4s linear infinite;\r\n}\r\n.wrrapper_form{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.cards.no{\r\n    margin-left: 0px;\r\n}\r\n.mainCt{\r\n    animation: errorAppear 1s ease-in-out;\r\n    animation-fill-mode: forwards;\r\n    background: linear-gradient(#065a65, #148c1ec2);\r\n   \r\n    box-sizing: border-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 10px 35px;\r\n    position: relative;\r\n    border-bottom-left-radius: 10px;\r\n    border-bottom-right-radius: 10px;\r\n\r\n\r\n}\r\n@keyframes errorAppear {\r\n    0% {\r\n        opacity: 0;\r\n\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n\r\n    }\r\n}\r\n.mainCtTable{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    /*margin: 0 auto;*/\r\n    margin-top: 20px;\r\n}\r\n@media (max-width: 550px) {\r\n    .variant_buttons div{\r\n        width: 23%;\r\n        font-size: 16px;\r\n        gap: 5px;\r\n    }\r\n    \r\n}\r\n.loadp{\r\n    text-align:center;\r\n    font-size:22px;\r\n    white-space: nowrap;\r\n}\r\n.loadp i {\r\n    display: inline-block; /* Делает иконку блочным элементом, чтобы она не влияла на текст */\r\n    margin-left: 3px; /* Добавляет отступ слева от иконки для разделения от текста */\r\n}\r\n.fadeBack{\r\n    animation: errorAppear 0.8s ease-in-out;\r\n    animation-fill-mode: forwards;\r\n    margin-left: 0px;\r\n}\r\n\r\n.history{\r\n    max-width: 700px!important;\r\n}\r\n.succsesIcon{\r\n    color:greenyellow;\r\n}\r\n.fa-spin{\r\n    color: #ff9c1d;\r\n}\r\n.order_id{\r\n    cursor: pointer;\r\n}\r\n.head_crypto {\r\n    color: white;\r\n    font-size: 20px;\r\n    font-family: \"Montserrat\", sans-serif;\r\n    padding: 10px;\r\n    position: relative;\r\n}\r\n.mainContCrypto{\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap:10px;\r\n    background-color: #0a0f23;\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    box-shadow: 0px 0px 8px 2px #000;\r\n}\r\n.blockInfCrypto{\r\n    display: flex;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    border: 2px solid #281e4b;\r\n    justify-content: center;\r\n    color:white;\r\n    font-family: monospace,sans-serif;\r\n}\r\n.wrapper_crypto{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap:8px;\r\n}\r\n\r\n.head_crypto:before {\r\n\r\n    content: \"\";\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: -10px;\r\n    width: 100%;\r\n    height: 2px;\r\n    background: #8080801f;\r\n    margin-bottom: 10px;\r\n\r\n\r\n}\r\n.blockInfoSupport{\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 10px;\r\n    align-items: center;\r\n    border-radius: 10px;\r\n    font-family: monospace,sans-serif;\r\n    background-color: rgba(0, 0, 0, 0.375);\r\n    cursor: pointer;\r\n    color:white!important;\r\n    margin-bottom: 5px;\r\n}\r\n.veriff-description{\r\n    display: none;\r\n}\r\n.blockInfoSupport.warning{\r\n    background-color: rgb(137 121 30 / 28%);\r\n    color:gold!important;\r\n    cursor: default;\r\n}\r\n.dangerIcon{\r\n    color:red;\r\n}\r\n.payment_block{\r\n    display: flex;\r\n    justify-content: center;\r\n    max-width: 800px;\r\n\r\n}\r\n.wrapper_payment{\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    \r\n    margin-top: 20px;\r\n\r\n\r\n}\r\n.wrapper_payment_block{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n@media screen and (max-width: 1000px) {\r\n    \r\n    .mainCt{\r\n        padding: 10px 10px;\r\n        display: flex;\r\n        width: 100%;\r\n    }\r\n    .payments{\r\n        margin-top: 60px;\r\n        margin-bottom: 50px;\r\n        min-height: 50svh;\r\n    }\r\n    \r\n   \r\n    .search-wrapper_payment.active .input-holder.pays{\r\n        width: 100%!important;\r\n    }\r\n\r\n    .loadp{\r\n        font-size: 17px!important;\r\n    }\r\n\r\n    .history{\r\n        max-width: 400px !important;\r\n    }\r\n\r\n}\r\n@media screen and (min-width: 1000px) {\r\n    \r\n\r\n    \r\n    .fadeBack {\r\n        margin: 20px 0px 10px 20px;\r\n    }\r\n    .card {\r\n        height: 120px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
